var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankbalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#FFD5C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4395 32.0754V34.613C24.4395 36.763 22.4395 38.5005 19.977 38.5005C17.5145 38.5005 15.502 36.763 15.502 34.613V32.0754C15.502 34.2254 17.502 35.7504 19.977 35.7504C22.4395 35.7504 24.4395 34.2129 24.4395 32.0754Z",
    stroke: "#F45C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4373 28.6374C24.4373 29.2624 24.2623 29.8374 23.9623 30.3374C23.2248 31.5499 21.7122 32.3124 19.9622 32.3124C18.2122 32.3124 16.6997 31.5374 15.9622 30.3374C15.6622 29.8374 15.4873 29.2624 15.4873 28.6374C15.4873 27.5624 15.9873 26.5999 16.7873 25.8999C17.5998 25.1874 18.7122 24.7625 19.9497 24.7625C21.1872 24.7625 22.2998 25.1999 23.1123 25.8999C23.9373 26.5874 24.4373 27.5624 24.4373 28.6374Z",
    stroke: "#F45C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4395 28.6375V32.075C24.4395 34.225 22.4395 35.75 19.977 35.75C17.5145 35.75 15.502 34.2125 15.502 32.075V28.6375C15.502 26.4875 17.502 24.75 19.977 24.75C21.2145 24.75 22.327 25.1875 23.1395 25.8875C23.9395 26.5875 24.4395 27.5625 24.4395 28.6375Z",
    stroke: "#F45C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5003 24.7124V27.2875C38.5003 27.975 37.9503 28.5375 37.2503 28.5625H34.8002C33.4502 28.5625 32.2128 27.575 32.1003 26.225C32.0253 25.4375 32.3252 24.7 32.8502 24.1875C33.3127 23.7125 33.9502 23.4375 34.6502 23.4375H37.2503C37.9503 23.4625 38.5003 24.0249 38.5003 24.7124Z",
    stroke: "#F45C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 24.125V21.625C13.5 18.225 15.55 15.85 18.7375 15.45C19.0625 15.4 19.4 15.375 19.75 15.375H31C31.325 15.375 31.6375 15.3875 31.9375 15.4375C35.1625 15.8125 37.25 18.2 37.25 21.625V23.4375H34.65C33.95 23.4375 33.3125 23.7125 32.85 24.1875C32.325 24.7 32.025 25.4375 32.1 26.225C32.2125 27.575 33.45 28.5625 34.8 28.5625H37.25V30.375C37.25 34.125 34.75 36.625 31 36.625H27.875",
    stroke: "#F45C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankbalance);
export default __webpack_public_path__ + "static/media/bankbalance.a4027c1d743bbfed2c1903d1f990a5f3.svg";
export { ForwardRef as ReactComponent };